// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"53f2f8c8","622":"53f2f8c8","915":"53f2f8c8"}[chunkId] + ".chunk.css";
};